















































import { UserPermission } from "@/shared/types";
import {
  Vue,
  Component,
  Prop,
  Watch
} from "@/shared/vuepack";
import { Validator } from "vee-validate";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useEmployerRolePermissionStore } from "@/admin/store/employerRolePermission";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";

@Component({ components: {} })
export default class RoleEdit extends Vue {

  $validator: Validator;
  featureFlagStore = useFeatureFlagStore();
  employerRolePermissionStore = useEmployerRolePermissionStore();
  rolePermissionStore = useRolePermissionsStore();

  get canEditPermission (): boolean {
    return this.featureFlagStore.flags.hsa4475allowRolePermissions
        ? this.rolePermissionStore.userHasAdminPermission(UserPermission.AdminPortalUserManagementEdit)
        : true;
  }


  role = {
    roleId: 0,
    roleType: null,
    roleName: "",
    permissions: []
  };

  permissions = [];
  options = [];
  editRoleMode = false;
  editPermissionMode = false;

  @Prop() roleId?: number;

  @Watch("employerRolePermissionStore.isRoleLoaded")
  @Watch("employerRolePermissionStore.isLoaded")
  initializeModel () {
    this.role = { ...this.employerRolePermissionStore.singleRole};
    this.options = this.employerRolePermissionStore.employerRolePermissions.map(x =>  ({text: x.permissionName, value: x.permissionId}));
    this.permissions = this.role.permissions;

  }

  mounted () {
    this.employerRolePermissionStore.getRoleById(this.roleId);
    this.employerRolePermissionStore.getUserManagementRolePermissions();
  }

  isLoaded () {
    return this.employerRolePermissionStore.isRoleLoaded && this.employerRolePermissionStore.isLoaded && this.roleId;
  }

  switchToEditRoleMode () {
    if (this.canEditPermission) {
      this.editRoleMode = true;
    }
  }

  revertEditRoleMode () {
    this.editRoleMode = false;
    this.role = { ...this.employerRolePermissionStore.singleRole};
  }

  switchToEditPermissionMode () {
    if (this.canEditPermission) {
      this.editPermissionMode = true;
    }
  }

  revertEditPermissionMode () {
    this.editPermissionMode = false;
    this.permissions = this.role.permissions;
  }

  onSubmit () {
    this.$validator.validateAll().then(valid => {
      if (valid) {
        this.employerRolePermissionStore.updateRole(this.role)
            .then(resp => {
              if (resp) {
                this.editRoleMode = false;
              }
            });
      }
    });
  }

  onPermissionSubmit () {
    this.role.permissions = this.permissions;
    this.employerRolePermissionStore.updatePermissionsByRole(this.role)
            .then(resp => {
              if (resp) {
                this.editPermissionMode = false;
              }
            });
  }

  returnToListPage () {
    this.$router.push("/role-permissions-management/role-permission-list");
  }
}
